import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/auth/google") {
      setReady(true);
      return;
    }
    const token = localStorage.getItem("ns_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); syncCountry(r.data); })
      .catch(() => {
        localStorage.removeItem("ns_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const syncCountry = (u) => {
    const c = u?.preferences?.country;
    if (c) localStorage.setItem("ns_default_country", c);
  };

  const login = (token, u) => {
    localStorage.setItem("ns_token", token);
    setUser(u);
    syncCountry(u);
  };
  const logout = () => {
    localStorage.removeItem("ns_token");
    setUser(false);
  };

  const updateUser = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
